











/* eslint-disable */

import Vue from "vue";
import VueRouter from 'vue-router'
//import Contact from "./components/Master/ContactUs";
import fb from "./components/config";
import Main from "./components/Master/main.vue";
import Login from "./components/Admin/login.vue"
import Index from "./components/Admin/index.vue"
//import router from "./router/routes.vue"

Vue.use(VueRouter);

const routes=[
  {path:'/login',component:Login},
  {path:'/',component:Main},
  {path:'/index',component:Index}
  ];

  const router=new VueRouter({
    routes
  })

export default Vue.extend({
  name: "app",
  router,
  components: {
    Login,Main
  },
  methods: {

  }
});
